import { tagApi } from '@/integrations/api';
import { useImmutableData } from '@binhatch/hooks';

export const useTags = () => {
  return useImmutableData({ key: 'useTags' }, async () => tagApi.listTags().then((r) => r.data.custom_tags));
};
